import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../Globals/constants';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { semanticColors } from '../../Globals/styles';

class ActivityEmployeeDrop extends Component {

  render() {
    const { connectDropTarget, isOver, shouldBeDropable } = this.props;

    return connectDropTarget(
      <div style={[styles.dropTarget, shouldBeDropable && styles.shouldBeDropable]}>
        {isOver &&
          <div style={styles.isOver}>
          </div>
        }
      </div>
    )
  }
}


var styles = {
  dropTarget: {
    height: '127px',
    position: 'absolute',
    width: '100%',
    top: '0',
    left: '0'
  },
  shouldBeDropable: {
    zIndex: '10'
  },
  isOver: {
    height: '127px',
    backgroundColor: semanticColors.info,
    opacity: '0.5'
  }
}

const ActivityEmployeeTarget = {
  drop(props, monitor) {
    //if component was already dropped - no nothing
    if(monitor.didDrop()) return;
    //if user NOT is already registered on this activity register him
    if (!props.isEmployeeAlreadyDropped(monitor.getItem().employeeId))
      props.registerHours(
        monitor.getItem().employeeIndex,
        props.activityId,
        monitor.getItem().employeeId)

    //set the employeeHours
    props.setEmployeeHours(monitor.getItem().employeeIndex, monitor.getItem().hours, monitor.getItem().isNight)


  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true })
  };
}
  ActivityEmployeeDrop.propTypes = {
    isOver: PropTypes.bool.isRequired,
    shouldBeDropable: PropTypes.bool.isRequired,
    activityId: PropTypes.string.isRequired,
    registerHours: PropTypes.func.isRequired,
    isEmployeeAlreadyDropped: PropTypes.func.isRequired,
    setEmployeeHours: PropTypes.func.isRequired
  };
export default DropTarget(dragNDropConstants.EMPLOYEE, ActivityEmployeeTarget, collect)(Radium(ActivityEmployeeDrop));


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/activityEmployeeDrop.jsx